import { useQuery, useQueryClient, UseQueryResult } from '@tanstack/react-query';
import { partnersApi } from 'App';

export type PartnerUI = { uuid: string; name: string; enableSelfService: boolean };

export function usePartners(enabled: boolean): UseQueryResult<PartnerUI[]> {
  const queryClient = useQueryClient();

  return useQuery(['all partners'], partnersApi.getAll, {
    select: (data) =>
      data.map((partner) => ({
        uuid: partner.uuid,
        name: partner.name,
        enableSelfService: partner.enableSelfService && partner.active,
      })),
    staleTime: 1000 * 60 * 60 * 24,
    onSuccess: (data) =>
      data.map((partner) => queryClient.setQueryData(['partners', partner.uuid], partner)),
    enabled,
  });
}
